import { JSX } from "react";
import playStoreBadge from "@/assets/img/playStoreBadge.svg";
import appStoreBadge from "@/assets/img/appStoreBadge.svg";
import dashboard2 from "@/assets/img/phone.png";
import { motion } from "framer-motion";

const styles = {
    section: "mx-auto max-w-7xl py-16 sm:px-6 lg:px-8",
    container: "relative isolate overflow-hidden bg-gray-900 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0 transition-all duration-500 hover:shadow-3xl",
    h2: "text-3xl font-bold tracking-tight text-white sm:text-4xl",
    p: "mt-6 text-lg leading-8 text-gray-300",
    badgesWrap: "mt-10 flex items-center justify-center gap-x-6 lg:justify-start",
    badgesInner: "mt-10 flex items-center justify-center gap-x-6 lg:justify-center",
    badgeImg: "object-contain transition-transform duration-200 hover:scale-110",
    leftCol: "mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-24 lg:text-left",
    rightCol: "relative mt-12 lg:mt-8",
    img: "absolute left-0 top-0 w-[25rem] max-w-none"
};

const DownloadAppSection = (): JSX.Element => {
    return (
        <motion.div
            className={styles.section}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ type: "spring", stiffness: 60, damping: 16 }}
            viewport={{ once: true, amount: 0.5 }}
        >
            <motion.div
                className={styles.container}
                initial={{ scale: 0.97, opacity: 0.8 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ type: "spring", stiffness: 80, delay: 0.1 }}
                viewport={{ once: true }}
            >
                <motion.div
                    className={styles.leftCol}
                    initial={{ x: -40, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ type: "spring", stiffness: 70, delay: 0.2 }}
                    viewport={{ once: true }}
                >
                    <motion.h2
                        className={styles.h2}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        viewport={{ once: true }}
                    >
                        Descarga la app de AppCotas hoy mismo.
                    </motion.h2>
                    <motion.p
                        className={styles.p}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.4 }}
                        viewport={{ once: true }}
                    >
                        Con AppCotas, tendrás todo lo que necesitas para gestionar la salud y el bienestar de tus mascotas al alcance de tu mano. Gestiona citas, controla sus tratamientos y recibe notificaciones en tiempo real.
                    </motion.p>
                    <motion.div
                        className={styles.badgesWrap}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <div className={styles.badgesInner}>
                            <motion.a
                                href="https://play.google.com/store"
                                target="_blank"
                                rel="noopener noreferrer"
                                whileHover={{ scale: 1.08 }}
                                transition={{ type: "spring", stiffness: 200, damping: 12 }}
                            >
                                <img
                                    src={playStoreBadge}
                                    alt="Get it on Google Play"
                                    width={160}
                                    height={60}
                                    className={styles.badgeImg}
                                />
                            </motion.a>
                            <motion.a
                                href="https://www.apple.com/app-store/"
                                target="_blank"
                                rel="noopener noreferrer"
                                whileHover={{ scale: 1.08 }}
                                transition={{ type: "spring", stiffness: 200, damping: 12 }}
                            >
                                <img
                                    src={appStoreBadge}
                                    alt="Download on the App Store"
                                    width={160}
                                    height={60}
                                    className={styles.badgeImg}
                                />
                            </motion.a>
                        </div>
                    </motion.div>
                </motion.div>

                <div className={styles.rightCol}>
                    <img
                        className={styles.img}
                        src={dashboard2}
                        alt="App screenshot"
                        width={1824}
                        height={1080}
                    />
                </div>
            </motion.div>
        </motion.div>
    );
}
export default DownloadAppSection;